"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var react_amphtml_1 = require("react-amphtml");
var ShareAmp_1 = require("@/pages/common/components/amp/ShareAmp");
var stripStyle_1 = require("@/utils/stripStyle");
var ServerSideSchema_1 = require("@/pages/common/components/schema/ServerSideSchema");
var mapStateToProps = function (state) { return ({
    articleSection: state.newsArticleDetail,
    relatedSection: state.newsAndInsights,
    tResult: state.resultPageTranslation,
    contact: state.contact,
    dfoot: state.dfoot,
    gtmId: state.server ? state.server.googleTagManagerAmpId : '',
    langCode: state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1,
}); };
var articleDetailAmp = function (props) {
    var safeContent = stripStyle_1.stripStyle(props.articleSection.data.content);
    var renderAuthor = function (props) {
        var author = props.articleSection.data.authorDetail;
        return author ? (React.createElement("div", { style: { paddingBottom: '40px' } },
            React.createElement("div", { className: "ct-wrap" },
                author.imageUrl ? (React.createElement("div", { className: "ct-image" },
                    React.createElement(react_amphtml_1.AmpImg, { specName: "default", width: "60", height: "60", src: author.imageUrl }))) : null,
                React.createElement("div", { className: "ct-info" },
                    React.createElement("div", { className: "ct-name" }, author.agentName),
                    author.company ? (React.createElement("div", { className: "ct-id" }, author.company)) : null,
                    React.createElement("div", { className: "ct-title" }, author.jobTitle),
                    React.createElement("div", { className: "ct-action" },
                        React.createElement("a", { href: author.viewMoreArticlesUrl, className: "ct-link" }, props.articleSection.translate.viewMoreArticles)))))) : null;
    };
    var renderAuthorTextLink = function (props) {
        var author = props.articleSection.data.authorDetail;
        return author ? (React.createElement(React.Fragment, null,
            "\u00A0",
            React.createElement("span", { className: "fal fa-pen-nib" }),
            "\u00A0",
            React.createElement("a", { href: author.agentUrl }, author.agentName))) : null;
    };
    var renderRelatedItem = function (it, i) {
        return (React.createElement("div", { className: "ra__it" },
            React.createElement("a", { href: it.url, className: "ra__img" },
                React.createElement(react_amphtml_1.AmpImg, { width: "130", height: "130", specName: "default", layout: "responsive", src: it.imageUrl })),
            React.createElement("div", { className: "ra__body" },
                React.createElement("a", { href: it.url, className: "ra__title" }, it.title),
                React.createElement("div", { className: "ra__date" },
                    React.createElement("span", { className: "fal fa-user" }),
                    "\u00A0\u00A0",
                    it.authors[0].name))));
    };
    var gtmAttrs = {
        'data-credentials': 'include',
    };
    var gtm = "https://www.googletagmanager.com/amp.json?id=" + props.gtmId + "&gtm.url=SOURCE_URL";
    return (React.createElement(React.Fragment, null,
        props.gtmId ? React.createElement(react_amphtml_1.AmpAnalytics, __assign({}, gtmAttrs, { config: gtm })) : null,
        React.createElement("div", { className: "ct" },
            React.createElement("div", { className: "nav-bar nav-bar--solid" },
                React.createElement(react_amphtml_1.Button, { on: "tap:menu", className: "nav-menu", specName: "default", id: "menubutton" },
                    React.createElement("span", { className: "fal fa-bars" })),
                React.createElement("a", { href: "#" },
                    React.createElement(react_amphtml_1.AmpImg, { width: "328", height: "60", specName: "default", layout: "fill", src: "https://www.okay.com/res/img/okay-logo.gif" }))),
            React.createElement("div", { className: "b__head" },
                React.createElement("div", { className: "b__title" }, props.articleSection.data.title),
                React.createElement("div", { className: "b__date" },
                    React.createElement("span", { className: "fal fa-calendar-day" }),
                    "\u00A0 ",
                    props.articleSection.data.lastUpdatedText.split(' - ')[0],
                    renderAuthorTextLink(props))),
            React.createElement("div", { style: { paddingBottom: '40px' } },
                React.createElement(ShareAmp_1.default, null)),
            React.createElement("div", { className: "b__body", dangerouslySetInnerHTML: { __html: safeContent } }),
            React.createElement("div", { style: { paddingBottom: '40px' } },
                React.createElement(ShareAmp_1.default, null)),
            renderAuthor(props),
            React.createElement("div", { className: "ds" },
                React.createElement("div", { className: "ds__tt" }, props.relatedSection.translate.youMayAlsoLike),
                React.createElement("div", { className: "ds__body" },
                    React.createElement("div", { className: "ra" }, props.relatedSection.newsAndInsights.map(renderRelatedItem)))),
            React.createElement("div", { className: "ca" },
                React.createElement("div", { className: "ca__tt" }, props.contact.heading),
                React.createElement("div", { className: "ca__body" },
                    React.createElement("div", { className: "ca__bg" },
                        React.createElement(react_amphtml_1.AmpImg, { width: "300", height: "300", layout: "fill", specName: "default", src: "https://images.okay.com/website/common/images/agents.jpg" })),
                    React.createElement("a", { href: "/" + props.langCode + "/communication/enquiry", className: "ca__btn", target: "_blank" }, props.contact.contactAgentButton))),
            React.createElement("div", { className: "ft" }, props.dfoot.nameFootCopyright)),
        React.createElement(ServerSideSchema_1.default, null)));
};
exports.default = react_redux_1.connect(mapStateToProps, function () { return ({}); })(articleDetailAmp);
